import React from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Sidebar, MobileSidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { ExportQueuePanel } from './ExportQueuePanel';
export function AppShell() {
  return <div className="flex h-screen w-full overflow-hidden bg-canvas text-navy-800" data-id="element-95">
      <Sidebar data-id="element-96" />
      <MobileSidebar data-id="element-97" />
      <div className="flex min-w-0 flex-1 flex-col" data-id="element-98">
        <TopBar data-id="element-99" />
        <main className="flex-1 overflow-y-auto thin-scroll" data-id="element-100">
          <Outlet data-id="element-101" />
        </main>
      </div>
      <ExportQueuePanel data-id="element-102" />
      <Toaster position="bottom-right" richColors closeButton data-id="element-103" />
    </div>;
}